<template>
  <form @submit.prevent="filterPosTransactions()">
    <div class="row">
      <div class="col-lg-4 col-md-4">
        <base-input
          type="text"
          :label="$t('posTransactionsPage.filterForm.txRefLbl')"
          placeholder=""
          v-model="txRef"
        >
        </base-input>
      </div>
      <div class="col-lg-2 col-md-2 pl-0 ">
        <base-input
          :label="$t('posTransactionsPage.filterForm.dateLbl')">
          <template>
            <el-date-picker
              v-model="date"
              type="date"
              unlink-panels
              align="center"
              :clearable="false"
              :start-placeholder="$t('posTransactionsPage.filterForm.datePlaceholder')">
            </el-date-picker>
          </template>
        </base-input>
      </div>
      <div class="col-lg-4 col-md-4 pl-0 align-self-end">
        <div class="form-group">
          <base-button
            :loading="loading"
            native-type="submit"
            type="default"
            class="btn-fill mb-0"
          ><i class="tim-icons icon-light-3 pr-2"/> {{ $t('posTransactionsPage.filterForm.actionBtn') }}
          </base-button>
        </div>
      </div>
    </div>
  </form>
</template>
<script>

  import {DatePicker} from 'element-ui';
  import {mapActions, mapState} from "vuex";

  export default {
    name: 'top-ups-filter-form',
    components: {
      [DatePicker.name]: DatePicker,
    },
    props: {
      filterDetails: {
        type: Object,
        required: false,
      },
    },
    methods: {
      ...mapActions(['LoadPosTransactions']),
      filterPosTransactions() {
        let apiQuery = {
          date: this.$options.filters.dateOnly(this.date),
          txRef: encodeURIComponent(this.txRef)
        }
        this.LoadPosTransactions(apiQuery)
      }
    },
    computed: {
      ...mapState({
        loading: state => state.pos_transactions.loading,
      }),
    },
    data() {
      return {
        date: new Date(),
        txRef: ""
      };
    },
    mounted() {
      if (this.filterDetails) {
        this.date = new Date(this.filterDetails.date)
        this.txRef = this.filterDetails.txRef
      }
    }
  };
</script>
<style>
</style>
